import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import HOC from '../../components/HOC/HOC';
import { SuccessfullyModal } from '../../components/Modals/Modals';
import addjob from '../../css/style.module.css';
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

const AddFunds = () => {
  const navigate = useNavigate();
  const [userid, setUserId] = useState('');
  const [staffid, setStaffId] = useState('');
  const [amount, setAmount] = useState(null);
  const [type, setType] = useState('Credit');
  const [show, setShow] = useState(false);
  const [users, setUsers] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const handleToggle = (action) => {
    setType(action);
  };

  const handleAmountClick = (recommendedAmount) => {
    setAmount(recommendedAmount);
  };

  const handleSubmit = async () => {
    const recipientId = userid || staffid;

    if (!recipientId) {
      toast.error('Please select a user or staff member.');
      return;
    }

    if (type === 'Debit' && amount > (selectedAccount?.wallet || 0) - 1) {
      toast.error(
        `You can redeem a maximum of ₹${
          (selectedAccount?.wallet || 0) - 1
        }. Your current wallet balance is ₹${selectedAccount?.wallet || 0}.`
      );

      return;
    }
    const payload = {
      amount: amount,
      type: type,
    };

    await postApi(endPoints.addfund(recipientId), payload, {
      setLoading,
      successMsg:
        type === 'Credit' ? 'Balance added successfully!' : 'Balance withdrawn successfully!',
      errorMsg: type === 'Credit' ? 'Failed to add Balance!' : 'Failed to withdraw Balance!',
    });
    setShow(true);

    setTimeout(() => {
      setShow(false);
      navigate(userid ? '/wallet-management/user' : '/wallet-management/staff');
    }, 2000);
  };

  const fetchData = async () => {
    await getApi(endPoints.getalluser(1, 99999), {
      setResponse: setUsers,
      setLoading: setLoading,
      errorMsg: 'Failed to fetch user!',
    });
  };

  const fetchDataStaff = async () => {
    await getApi(endPoints.getallstaff, {
      setResponse: setStaffs,
      setLoading: setLoading,
      errorMsg: 'Failed to fetch user!',
    });
  };

  useEffect(() => {
    fetchData();
    fetchDataStaff();
  }, []);

  const userList = users?.data?.docs || [];
  const staffList = staffs?.data || [];

  return (
    <>
      <SuccessfullyModal
        show={show}
        handleClose={() => setShow(false)}
        text={type === 'Credit' ? 'Funds Added Successfully' : 'Funds Withdrawn Successfully'}
      />
      <div className={addjob.jobmanagementCotainer}>
        <div className={addjob.jobtoppart}>
          <div className={addjob.pagetitle}>
            <h6>{type === 'Credit' ? 'Add Funds' : 'Withdraw Funds'}</h6>
          </div>
          <div className={addjob.rightbuttons}>
            <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
              <p>Wallet List</p>
            </div>
          </div>
        </div>

        <div className={addjob.addjobcontainer}>
          <div className={addjob.addjobsubcontainer}>
            <div className={addjob.addjobtopic}>
              <h6>Wallet Details</h6>
            </div>
            <div className={addjob.addjobinputs}>
              <label htmlFor="">User Name*</label>
              <select
                value={userid || ''}
                onChange={(e) => {
                  const selectedUser = userList.find((user) => user._id === e.target.value);
                  setUserId(e.target.value);
                  setStaffId('');
                  setSelectedAccount(selectedUser || null);
                }}
              >
                <option value="">Select User</option>
                {userList.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.firstName} {user.lastName}
                  </option>
                ))}
              </select>
            </div>
            <div className={addjob.addjobinputs}>
              <label htmlFor="">Staff Name*</label>
              <select
                value={staffid || ''}
                onChange={(e) => {
                  const selectedStaff = staffList.find((user) => user._id === e.target.value);
                  setStaffId(e.target.value);
                  setUserId('');
                  setSelectedAccount(selectedStaff || null);
                }}
              >
                <option value="">Select staff</option>
                {staffList.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.firstName} {user.lastName}
                  </option>
                ))}
              </select>
            </div>
            <div className={addjob.addjobinputs}>
              <label htmlFor="">Choose Action*</label>
              <div className={addjob.rightbuttons}>
                <div
                  className={`${addjob.withdraw} ${type === 'Credit' ? addjob.active : ''}`}
                  onClick={() => handleToggle('Credit')}
                >
                  <p>Add Funds</p>
                </div>
                <div
                  className={`${addjob.withdraw} ${type === 'Debit' ? addjob.active : ''}`}
                  onClick={() => handleToggle('Debit')}
                >
                  <p>Withdraw</p>
                </div>
              </div>
            </div>
            <div className={addjob.addjobinputs}>
              <label htmlFor="">Choose Amount*</label>
              <input
                type="number"
                placeholder="Enter Amount"
                value={amount || ''}
                onChange={(e) => setAmount(e.target.value)}
              />
              <div className={addjob.addfundcontainer}>
                <span>Recommended</span>
                <div className={addjob.rightbuttons}>
                  {[200, 500, 1000].map((amt) => (
                    <div
                      key={amt}
                      className={`${addjob.withdraw} ${amount === amt ? addjob.active : ''}`}
                      onClick={() => handleAmountClick(amt)}
                    >
                      <p>{amt}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className={addjob.addjobbutton}>
            <div className={addjob.rightbuttons}>
              <button onClick={() => navigate(-1)}>Cancel</button>
            </div>
            <div className={addjob.rightbuttons}>
              <button
                onClick={handleSubmit}
                style={{ background: '#F05423' }}
                disabled={loading || !amount || !type || (!userid && !staffid)}
              >
                {loading
                  ? type === 'Credit'
                    ? 'Adding...'
                    : 'Withdrawing...'
                  : type === 'Credit'
                  ? 'Add'
                  : 'Withdraw'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HOC(AddFunds);
